/**
 请求拦截器: 发送请求前的处理
**/
// import store from '@/page/store';
import { getUserId } from '@/utils/getUser'
/*
 自动在header带上token
*/
export const takeTokenHandle = config => {
  // 如果请求的接口不是/login或/register，那么是需要在header中传token
  if (config.url.indexOf('/login') < 0 && config.url.indexOf('/register') < 0) {
    // 如果不存在，则自动带上
    if (!('TOKEN' in config.headers)) {
      config.headers['Authorization'] = localStorage.getItem('TOKEN');
    }
  }
  config.headers['UserId'] = getUserId()
  config.headers['AppId'] = 'vh'
  config.headers['osType'] = 'h5'

  return config;
};

/*
 忽略post, put参数值为undefined, null, ''的参数
*/
export const ignoreViolationParamsHandle = config => {
  if (config.method.toLowerCase() !== 'get' && config.data) {
    if (!Array.isArray(config.data)) {
      const isFormdata = config.data instanceof FormData;
      const memo = isFormdata ? new FormData : {};

      if (isFormdata) {
        for (let key of config.data.keys()) {
          if (config.data.get(key) !== void 0 && config.data.get(key) !== '')
          memo.append(key, config.data.get(key));
        }
      } else {
        Object
          .keys(config.data)
          .filter(key => config.data[ key ] !== void 0)
          .reduce((mo, key) => {
            mo[ key ] = config.data[ key ];
            return mo;
          }, memo);
      }
      config.data = memo;
    }
  }
  return config;
};

/*
 所有非get并且content-type为json的字符串字段去除首尾空白字符
 */
export const trimHandle = config => {
  if (config.method.toLowerCase() !== 'get' && config.data && config.headers[ 'Content-Type' ].indexOf('json') > 0) {
    const body = config.data;
    if (!Array.isArray(body)) {
      config.data = Object.keys(body).reduce((memo, key) => {
        if (typeof body[ key ] === 'string') {
          memo[ key ] = body[ key ].trim();
        } else {
          memo[ key ] = body[ key ];
        }

        return memo;
      }, {});
    }
  }

  return config;
};
